import { SET_DASHBOARD_TITLE, TOGGLE_SIDEBAR } from "../Actions/types";

const INITIAL_STATE = {
  headerTitle: "Dashboard",
  isSidebarOpen: true,
};

const commonReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SET_DASHBOARD_TITLE:
      return { ...state, headerTitle: action.payload || "Dashboard" };
    case TOGGLE_SIDEBAR:
      return { ...state, isSidebarOpen: !state.isSidebarOpen };
    default:
      return state;
  }
};

export default commonReducer;
